import React from 'react';
import PropTypes from "prop-types";

const Tag = (props) => {
    return (
        <div className={'ant-tag' + (props.className == null ? '' : ' ' + props.className) + (props.color == null ? '' : ' ant-tag-' + props.color)} onClick={props.onClick}>
            {props.icon == null ? null : props.icon}
            <span>{props.children}</span>
        </div>
    );
}

Tag.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.element,
    onClick: PropTypes.func,
    color: PropTypes.oneOf(["success", "processing", "error", "default", "warning", "pink", "red", "yellow", "orange", "cyan", "green", "blue", "purple", "geekblue", "magenta", "volcano", "gold", "lime"]),
};
Tag.defaultProps = {
    color: 'default',
    onClick: null,
}

export default Tag;